import styled, { css } from "styled-components";
import { theme } from "../../../constants/StyledComponents";

type StyledModalProps = {
  $showFooter?: boolean;
  $fullSize?: boolean;
  $fullScreen?: boolean;
};

export const StyledModal = styled.div<StyledModalProps>`
  width: 100dvw;
  height: 100dvh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9990;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  & > .modal-box {
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: space-between;
    background: ${theme.colors.white};
    min-width: ${({ $fullSize }) => ($fullSize ? "900px" : "600px")};
    max-height: ${({ $fullScreen }) => ($fullScreen ? "100dvh" : "90%")};
    max-width: ${({ $fullScreen }) => ($fullScreen ? "100dvw" : "90%")};

    ${({ $fullSize }) =>
      $fullSize &&
      `
        width: 80%;
        height: 80%;
    `}

    ${({ $fullScreen }) =>
      $fullScreen &&
      css`
        width: 100dvw;
        height: 100dvh;
        min-width: unset;
        border-radius: 0;
      `}

    ${({ $fullScreen }) =>
      !$fullScreen &&
      css`
        @media (max-width: ${theme.breakpoints.MD}px) {
          min-width: unset;
          width: calc(100vw - 40px);
          max-height: 80dvh;
        }
      `}

    box-shadow: ${theme.variables.modal_box_shadow};
    border-radius: ${({ $fullScreen }) =>
      $fullScreen ? "0" : `${theme.variables.border_radius_1}`};

    & > .modal-header {
      height: 72px;
      background-color: ${theme.colors.page_background};
      border-radius: ${theme.variables.border_radius_1}
        ${theme.variables.border_radius_1} 0 0;
      padding: 27px 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    & > .modal-content {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      overscroll-behavior: none;
      scrollbar-gutter: stable;
      height: 100%;
      background-color: ${theme.colors.white};
      padding: ${({ $fullSize, $fullScreen }) =>
        $fullScreen ? "0" : $fullSize ? "20px 24px 0px 24px" : "20px 24px"};
      border-radius: ${(props) =>
        props.$showFooter
          ? "0"
          : `0 0 ${theme.variables.border_radius_1}
        ${theme.variables.border_radius_1}`};
    }

    & > .modal-footer {
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid ${theme.colors.purple_2};
      background-color: ${theme.colors.white};
      //prettier-ignore
      border-radius: 0 0 ${theme.variables.border_radius_1} ${theme.variables
        .border_radius_1};
      box-sizing: border-box;
      height: 72px;
      padding: 12px 20px;

      & > .modal-footer-right {
        display: flex;
        flex-direction: row;
        gap: 20px;
        justify-content: end;
        align-items: center;
      }

      @media (max-width: ${({ theme }) => theme.breakpoints.MD}px) {
        gap: 0px;
      }
    }
  }
`;
